import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const expertiseImageIds = ['supply-chain', 'europe-career', 'young-professionals'];

const expertiseImages: Record<string, string> = {
  'supply-chain': 'https://readdy.ai/api/search-image?query=Modern%20supply%20chain%20and%20logistics%20operations%20center%20with%20digital%20dashboards%20showing%20global%20routes%20and%20inventory%20data%20clean%20professional%20environment%20with%20blue%20and%20white%20color%20tones%20sophisticated%20industrial%20aesthetic%20professional%20photography&width=800&height=600&seq=expertise-supplychain-01&orientation=landscape',
  'europe-career': 'https://readdy.ai/api/search-image?query=Aerial%20view%20of%20a%20modern%20European%20city%20skyline%20with%20contemporary%20office%20buildings%20and%20green%20parks%20on%20a%20bright%20sunny%20day%20with%20soft%20clouds%20professional%20and%20aspirational%20atmosphere%20warm%20natural%20lighting%20editorial%20photography&width=800&height=600&seq=expertise-europe-02&orientation=landscape',
  'young-professionals': 'https://readdy.ai/api/search-image?query=Young%20professional%20working%20at%20a%20modern%20co-working%20space%20with%20laptop%20and%20notebook%20bright%20natural%20light%20contemporary%20minimalist%20interior%20design%20with%20green%20plants%20fresh%20and%20energetic%20vibe%20professional%20lifestyle%20photography&width=800&height=600&seq=expertise-youngpro-03&orientation=landscape',
};

export default function ExpertiseSection() {
  const { t } = useTranslation();

  return (
    <section id="expertise" className="py-20 md:py-28 px-6 md:px-10 lg:px-16 bg-background-100">
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center mb-14">
          <p className="text-xs font-semibold uppercase tracking-widest text-foreground-400 mb-3">
            {t('expertise.label')}
          </p>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 leading-tight">
            {t('expertise.title')} <span className="italic text-accent-600">{t('expertise.highlight')}</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {expertiseImageIds.map((id) => (
            <div
              key={id}
              className="group relative h-[420px] rounded-2xl overflow-hidden cursor-pointer"
            >
              <img
                src={expertiseImages[id]}
                alt={t(`expertise.items.${id}.title`)}
                className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-primary-950/85 via-primary-950/30 to-transparent" />

              <div className="absolute inset-0 flex flex-col justify-end p-6 md:p-8">
                <p className="text-xs font-semibold uppercase tracking-widest text-accent-300 mb-2">
                  {t(`expertise.items.${id}.subtitle`)}
                </p>
                <h3 className="font-heading text-2xl md:text-3xl font-bold text-white mb-3">
                  {t(`expertise.items.${id}.title`)}
                </h3>
                <p className="text-sm text-foreground-200 leading-relaxed max-w-sm">
                  {t(`expertise.items.${id}.description`)}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-10 text-center">
          <Link
            to="/expertise"
            className="inline-flex items-center gap-2 px-6 py-3 text-sm font-semibold text-primary-500 hover:text-primary-600 border border-primary-200 hover:border-primary-300 rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            {t('home.viewExpertise')}
            <i className="ri-arrow-right-line" />
          </Link>
        </div>
      </div>
    </section>
  );
}